export enum localStorageConstants {
  DARKMODE = 'smartaccupay-darkmode',
  LANGUAGE = 'smartaccupay-sitelanguage',
  USERTYPE = 'smartaccupay-usertype',
  USERDATA = 'smartaccupay-userdata',
  COMPANY_AND_USER_PICTURE = 'CompanyAndUserPicture',
  USERROLE = 'smartaccupay-userrole',
  INVOICE_TOKEN = 'smartaccupay-token',
  INVOICE_GIF = 'smartaccupay-gif',
  COMPANYCODE = 'smartaccupay-companycode',
  LOGOUT = 'smartaccupay-logout',
  //THEME = 'smartaccupay-theme',
  USER_DISPLAY = 'smartaccupay-userlist',
  VENDOR_DISPLAY = 'smartaccupay-vendorlist',
  COMPANYID = 'smartaccupay-companyid',
  COMPANYDATA = 'smartaccupay-companydata',

  SUPERADMIN_DATA = 'smartaccupay-superadmin-data',
  SUPERADMIN_ROLE = 'smartaccupay-superadmin-role',
  SUPERADMIN_TOKEN = 'smartaccupay-superadmin-token',
  SUPERADMIN_LOGOUT = 'smartaccupay-superadmin-logout',
  HELP_FILE_URL = "help_file_url",

  CHOOSE_SKIN = 'choose_skin',
  CHOOSE_SKIN_ACTIVE = 'choose_skin_active',
  MENU_OPTION = 'menuOption',
  CHOOSE_LOGO_HEADER = 'choose_logoheader',
  THEME = 'theme',

}
